import { useNavigate } from "react-router-dom";
import { Instagram, Trash2 } from "lucide-react";
import { mediaUrl, isHostedVideo } from "@/lib/api";

const FALLBACK = "https://images.unsplash.com/photo-1547592180-85f173990554?crop=entropy&cs=srgb&fm=jpg&q=85&w=800";

export default function RecipeCard({ recipe, index = 0, flat = false, onDelete }) {
  const navigate = useNavigate();
  const hasVideo = isHostedVideo(recipe.video_url);
  const isReel = hasVideo || /instagram\.com\/reel/i.test(recipe.video_url || "");
  const shape = flat
    ? "rounded-none bg-nerd-depth cursor-pointer hover:z-10 hover:brightness-110"
    : "rounded-2xl bg-nerd-depth cursor-pointer border border-black/5 hover:border-black/30 hover:-translate-y-1";
  return (
    <div
      data-testid={`recipe-card-${recipe.id}`}
      onClick={() => navigate(`/recipe/${recipe.id}`)}
      className={`group relative overflow-hidden transition-all duration-300 animate-fade-up aspect-[9/16] ${shape}`}
      style={{ animationDelay: `${index * 60}ms` }}
    >
      {hasVideo ? (
        <video
          data-testid="recipe-card-video"
          autoPlay loop muted playsInline
          poster={recipe.thumbnail ? mediaUrl(recipe.thumbnail) : undefined}
          className="absolute inset-0 w-full h-full object-cover"
          src={mediaUrl(recipe.video_url)}
        />
      ) : (
        <img
          src={mediaUrl(recipe.thumbnail) || FALLBACK}
          alt={recipe.title}
          className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      )}
      {isReel && (
        <span data-testid="reel-badge" className="absolute top-3 right-3 inline-flex items-center gap-1 bg-black/55 backdrop-blur-md text-white text-[11px] font-semibold px-2 py-1 rounded-full">
          <Instagram className="w-3.5 h-3.5" /> Reel
        </span>
      )}
      {onDelete && (
        <button
          data-testid={`recipe-delete-${recipe.id}`}
          onClick={(e) => { e.stopPropagation(); onDelete(recipe); }}
          title="Delete recipe"
          className="absolute top-3 left-3 z-20 w-9 h-9 rounded-full bg-black/55 backdrop-blur-md text-white flex items-center justify-center opacity-0 group-hover:opacity-100 hover:bg-coral transition-all"
        >
          <Trash2 className="w-4 h-4" />
        </button>
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/10 to-transparent flex items-end p-4">
        <h3 className="font-display font-bold text-white text-lg leading-tight line-clamp-2">{recipe.title}</h3>
      </div>
    </div>
  );
}
